import { api } from '../boot/axios'

export async function fetchStripeTerminalConnectionToken () {
  const { data } = await api.post('/payments/stripe/terminal/connection-token')
  return data?.secret
}

export async function registerStripeReader ({ locationId, registrationCode, label, salesRegisterId }) {
  const { data } = await api.post('/payments/stripe/terminal/register-reader', {
    location_id: locationId,
    registration_code: registrationCode,
    label,
    sales_register_id: salesRegisterId
  })
  return data
}

export async function syncStripeReaders (locationId) {
  const { data } = await api.post('/payments/stripe/terminal/sync-readers', {
    location_id: locationId
  })
  return data
}

export async function fetchStripeTapToPayConfig (params = {}) {
  const { data } = await api.get('/payments/stripe/tap-to-pay/config', { params })
  return data
}

export async function fetchStripeKeyedEntryConfig () {
  const { data } = await api.get('/payments/stripe/keyed-entry/config')
  return data
}
